<template>
    <div class="report__content" v-if="this.isAvailable">
        <div class="wrapper">
            <h2 class="report__title">Zgłoszenie <code>{{ this.caseId }}</code></h2>
        </div>
        <hr>
        <div class="wrapper">
            <h3 class="report__title">Dane pacjenta</h3>
            <div class="form__row form__row--center">
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Wiek</h4>
                    <input type="number" v-model="patientData.age" min="0" disabled="disabled">
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Płeć</h4>
                    <div class="form__label-group">
                        <label class="form__radio-label">
                            <input type="radio" v-model="patientData.sex" value="female" disabled="disabled">
                            <div class="radio"></div>
                            <p>K</p>
                        </label>
                        <label class="form__radio-label">
                            <input type="radio" v-model="patientData.sex" value="male" disabled="disabled">
                            <div class="radio"></div>
                            <p>M</p>
                        </label>
                    </div>
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Waga</h4>
                    <input type="number" v-model="patientData.weight" min="0" step="0.1" placeholder="kg"
                           disabled="disabled">
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Wzrost</h4>
                    <input type="number" v-model="patientData.height" min="0" step="0.1" placeholder="cm"
                           disabled="disabled">
                </div>
            </div>
        </div>
        <hr>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Krótki opis przypadku</h4>
                <div class="form__col--full">
                    <textarea rows="4" v-model="medicalData.shortDescription" disabled="disabled"></textarea>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Lokalizacja guza pierwotnego</h4>
                <div class="form__col--full">
                    <input type="text" class="form__field" v-model="medicalData.primaryTumorLocation"
                           disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Operacja raka jelita grubego/odbytnicy (rodzaj zabiegu i data)</h4>
                <div class="form__col--full">
                    <textarea rows="4" v-model="medicalData.typeOfPrimaryTumorSurgeryPerformed"
                              disabled="disabled"></textarea>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Powikłania pooperacyjne</h4>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.postoperativeComplications.postoperativeFistula"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>Przetoka pooperacyjna</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.postoperativeComplications.infection"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>Zakażenie</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.postoperativeComplications.abscess"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>Ropień</span>
                    </label>
                </div>
                <div class="form__col-1-2 form__col--inline">
                    <label>
                        <input type="checkbox" v-model="medicalData.postoperativeComplications.other"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>Inne:</span>
                    </label>
                    <input type="text" class="form__field--inline"
                           v-model="medicalData.postoperativeComplications.description" disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Histopatologiczne rozpoznanie guza</h4>
                <div class="form__col--full">
                    <textarea rows="4" v-model="medicalData.histopathologicalDiagnosisOfTheTumor"
                              disabled="disabled"></textarea>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Klasyfikacja guza w TNM</h4>
                <div class="form__col--full">
                    <input type="text" class="form__field" v-model="medicalData.tnmTumorClassification"
                           disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Mutacje</h4>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.mutations.KARS" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>KRAS</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.mutations.BRAF" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>BRAF</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.mutations.other" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>Inne:</span>
                    </label>
                    <input type="text" v-model="medicalData.mutations.description" disabled="disabled"/>
                </div>
            </div>
        </div>
        <hr/>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Leczenie adjuwantowe</h4>
                <div class="form__col--full">
                    <label class="form__label--inline">
                        <input type="checkbox" v-model="medicalData.adjuvantTreatment.chemotherapy"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>chemioterapia:</span>
                    </label>
                    <div v-if="medicalData.adjuvantTreatment.chemotherapy" class="form__row">
                        <div class="form__col-1-3">
                            <h4 class="form__field-title">Rodzaj chemioterapii</h4>
                            <input type="text" class="form__field--inline"
                                   v-model="medicalData.adjuvantTreatment.chemotherapyType" disabled/>
                        </div>
                        <div class="form__col-1-3">
                            <h4 class="form__field-title">Liczba kursów</h4>
                            <input type="number" class="form__field--inline"
                                   v-model="medicalData.adjuvantTreatment.chemotherapyAmount" disabled/>
                        </div>
                        <div class="form__col-1-3">
                            <h4 class="form__field-title">Data ostatniego kursu</h4>
                            <input type="text" class="form__field--inline"
                                   :value="displayDate(medicalData.adjuvantTreatment.endDateOfTheLastCourse.date)"
                                   disabled/>
                        </div>
                        <hr class="form__col--full mt-8">
                    </div>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.adjuvantTreatment.radiotherapy"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>radioterapia</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.adjuvantTreatment.hormoneTherapy"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>hormonoterapia</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="medicalData.adjuvantTreatment.monoclonalAntibodies"
                               disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>przeciwciała monoklonalne</span>
                    </label>
                </div>
            </div>
        </div>
        <hr/>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Inne operacje wykonane w przeszłości</h4>
                <textarea rows="4" v-model="medicalData.otherOperationsPerformedInThePast"
                          disabled="disabled"></textarea>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Lokalizacja przerzutów do wątroby (orientacyjna)</h4>
                <input type="text" v-model="medicalData.locationOfLiverMetastases" disabled="disabled"/>
            </div>
            <div class="form__row">
                <h4 class="form__row-title">Opis z badań obrazowych</h4>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">Liczba</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="medicalData.descriptionOfImagingTests.amount" disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">Wielkość</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="medicalData.descriptionOfImagingTests.size" disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">Segmenty</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="medicalData.descriptionOfImagingTests.segments" disabled="disabled"/>
                </div>
            </div>
        </div>
        <hr/>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Choroby współistniejące</h4>
                <input type="text" v-model="medicalData.comorbidities" disabled="disabled"/>
            </div>
        </div>
        <hr/>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Stosowane leki przeciwzakrzepowe/antykoagulanty</h4>
                <input type="text" v-model="medicalData.anticoagulantsUsed" disabled="disabled"/>
            </div>
        </div>
        <hr>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Markery nowotworowe</h4>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">CEA</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="findings.presenceOfTumorMarkers.CEA" disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">CA 19-9</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="findings.presenceOfTumorMarkers.CA199" disabled="disabled"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__col-1-6">AFP</div>
                <div class="form__col-1-6">
                    <input type="text" v-model="findings.presenceOfTumorMarkers.AFP" disabled="disabled"/>
                </div>
            </div>
        </div>
        <hr/>
        <div class="wrapper">
            <div class="form__row">
                <h4 class="form__row-title">Wirusowe zapalenie wątroby</h4>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="findings.presence.HBsAg" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>HBsAg</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="findings.presence.antiHCV" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>anty-HCV</span>
                    </label>
                </div>
                <div class="form__col-1-3">
                    <label>
                        <input type="checkbox" v-model="findings.presence.positiveAntiHBC" disabled="disabled"/>
                        <div class="checkbox"></div>
                        <span>dodatnie antyHBC</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex"

export default {
    name: "Summary",
    data() {
        return {
            isAvailable: false,
            caseId: '',
            patientData: {
                age: '',
                sex: '',
                weight: '',
                height: '',
            },
            medicalData: {
                shortDescription: '',
                primaryTumorLocation: '',
                typeOfPrimaryTumorSurgeryPerformed: '',
                postoperativeComplications: {
                    postoperativeFistula: false,
                    infection: false,
                    abscess: false,
                    other: false,
                    description: ''
                },
                histopathologicalDiagnosisOfTheTumor: '',
                tnmTumorClassification: '',
                mutations: {
                    KARS: false,
                    BRAF: false,
                    other: false,
                    description: ''
                },
                adjuvantTreatment: {
                    radiotherapy: false,
                    hormoneTherapy: false,
                    monoclonalAntibodies: false,
                    chemotherapy: false,
                    endDateOfTheLastCourse: ''
                },
                otherOperationsPerformedInThePast: '',
                locationOfLiverMetastases: '',
                descriptionOfImagingTests: {
                    amount: '',
                    size: '',
                    segments: ''
                },
                comorbidities: '',
                anticoagulantsUsed: ''
            },
            findings: {
                presenceOfTumorMarkers: {
                    CEA: "",
                    CA199: "",
                    AFP: ""
                },
                presence: {
                    HBsAg: false,
                    antiHCV: false,
                    positiveAntiHBC: false
                }
            }
        }
    },
    computed: mapGetters({
        securedRequestHeader: "getSecuredRequestHeader",
    }),
    methods: {
        displayDate(fulldate) {
            const date = new Date(fulldate);
            return date.toLocaleString('pl-PL').split(',')[0]
        }
    },
    beforeMount() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/medical-case/${this.$route.params.id}`, {
                headers: this.securedRequestHeader,
            })
            .then((response) => {
                this.uuid = response.data.id;
                this.caseId = response.data.shortId;
                this.patientData = response.data.summary.patientData;
                this.medicalData = response.data.summary.medicalData;
                this.findings = response.data.summary.findings;
                this.isAvailable = true;
            })
            .catch(() => {
                this.isAvailable = false;
            })
    }
}
</script>

<style lang="scss">
.report {
    &__id {
        font-family: 'Source Code Pro', sans-serif;
        text-align: center;
        background: #36BACA;
        border-radius: 50px;
        padding: 10px;
        margin-bottom: 30px;
        color: #fff;
    }
}

.patient {
    &__desc {
        text-align: center;
    }

    &__form {
        padding-bottom: 50px;
    }
}
</style>
